import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconHelpOutline } from '@travel-frontend/icons';
import { Trans, useTranslation } from 'next-i18next';
import { Container } from '../../../../components/PriceOverviewCard/components/TouroperatorVoucherInfo/components/Container.js';
import { Flex, LabelSmall, Tag, Tooltip } from '../../../../primitives/index.js';
export const TouroperatorVoucherInfo = () => {
  const {
    t
  } = useTranslation();
  return _jsxs(Container, {
    children: [_jsx(Tag, {
      children: t('priceOverviewCard:touroperatorVoucher.activated')
    }), _jsxs(Flex, {
      gap: "global/medium",
      direction: "row",
      children: [_jsx(LabelSmall, {
        color: "contentSecondary",
        children: t('priceOverviewCard:touroperatorVoucher.tooltip')
      }), _jsx(Tooltip, {
        tooltipElement: "IconHelpOutline",
        tooltipText: t('priceOverviewCard:touroperatorVoucher.tooltipContent'),
        content: _jsx(Trans, {
          i18nKey: "priceOverviewCard:touroperatorVoucher.tooltipContent",
          components: [_jsxs(_Fragment, {
            children: [_jsx("br", {}), _jsx("br", {})]
          })]
        }),
        children: _jsx(IconHelpOutline, {
          tabIndex: 0,
          fontScale: "small"
        })
      })]
    })]
  });
};